import React from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './Button.module.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'transparent' | 'gradient';

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    loading?: boolean;
    size?: 'md' | 'lg';
    block?: boolean;
}

const BRAND_CLASSES: Record<ButtonVariant, {en: string, ru?: string}> = {
    primary: {en: styles.primaryEn},
    secondary: {en: styles.secondaryEn, ru: styles.secondaryRu},
    transparent: {en: styles.transparentEn, ru: styles.transparentRu},
    gradient: {en: styles.gradientEn, ru: styles.gradientRu},
};

const Button: React.FC<IButtonProps> = ({
    variant = 'primary',
    loading,
    disabled,
    className,
    children,
    type = 'button',
    size = 'md',
    block,
    ...rest
}) => {
    const isInactive = disabled || loading;
    const brand = BRAND_CLASSES[variant];

    return (
        <button
            {...rest}
            type={type}
            disabled={isInactive}
            aria-disabled={isInactive}
            aria-busy={loading}
            className={cn(
                variant === 'primary' && ['btn', styles.btn],
                styles[variant],
                isTranslate() ? brand.en : brand.ru,
                {
                    [styles.loading]: loading,
                    [styles.primaryDisabled]: variant === 'primary' && disabled,
                    [styles.sizeLg]: size === 'lg',
                    [styles.block]: block,
                },
                className,
            )}
        >
            {loading && <span className={styles.spin}/>}
            {children}
        </button>
    );
};

export default Button;
